import { useTranslation } from "react-i18next";
import { classNames } from "../../ui/styles/classNames";
import CommandLine from "./CommandLine";
import { useConnectorServerAddress } from "./useConnectorServerAddress";

/**
 * `dmw-connector pair <address>`, with the address connectors pair with as the server reports
 * it, so the pairing link always lands on this web app.
 */
export default function PairCommand({ className }: { className?: string }) {
  const { t } = useTranslation();
  const server = useConnectorServerAddress();
  if (server.kind === "loading") return null;
  if (server.kind === "not_configured") {
    return <p className={classNames("app-text-muted text-xs", className)}>{t("connectors.pairCommand.notConfigured")}</p>;
  }
  return <CommandLine command={`dmw-connector pair ${server.address}`} className={className} />;
}
